let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3O0ky")).then(() => parcelRequire('dEbhi'));